import { addingCalendarLoadingText } from './SharingAcceptButton.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import * as Constants from '../utils/constants';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import SharingMessage from 'owa-service/lib/contract/SharingMessage';
import SharingMessageActionType from 'owa-service/lib/contract/SharingMessageActionType';
import createSharingMessageActionText from '../utils/createSharingMessageActionText';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import getSharingMessageAction from '../utils/getSharingMessageAction';
import acceptInvite from '../actions/acceptInvite';
import showCalendar from '../actions/showCalendar';

import { observer } from 'mobx-react';

const styles = require('../styles/SharingAcceptButton.scss');

export interface SharingAcceptButtonProps {
    item: SharingMessage;
}

export interface SharingAcceptButtonState {
    isLoading: boolean;
    successfulAccept: boolean;
}

@observer
export default class SharingAcceptButton extends React.Component<
    SharingAcceptButtonProps,
    SharingAcceptButtonState
> {
    constructor(props: SharingAcceptButtonProps) {
        super(props);
        this.state = { isLoading: false, successfulAccept: false };
    }

    render() {
        const { item } = this.props;

        const sharingMessageAction = getSharingMessageAction(item);
        return this.renderActionButton(sharingMessageAction);
    }

    private renderActionButton(sharingMessageAction: SharingMessageActionType): JSX.Element {
        if (!sharingMessageAction) {
            return null;
        }

        if (this.state.isLoading) {
            return (
                <div>
                    <Spinner className={styles.spinner} size={SpinnerSize.small} />
                    <span>{loc(addingCalendarLoadingText)}</span>
                </div>
            );
        }

        const primary: boolean = sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;

        if (this.state.successfulAccept) {
            const text = createSharingMessageActionText(Constants.VIEW_CALENDAR);

            return primary ? (
                <PrimaryButton text={text} onClick={this.onViewCalendarButtonClicked} />
            ) : (
                <DefaultButton text={text} onClick={this.onViewCalendarButtonClicked} />
            );
        } else {
            const action = this.state.successfulAccept
                ? Constants.VIEW_CALENDAR
                : sharingMessageAction.Action;
            const text = createSharingMessageActionText(action);
            const primary: boolean =
                sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;

            return primary ? (
                <PrimaryButton text={text} onClick={this.onAcceptButtonClicked} />
            ) : (
                <DefaultButton text={text} onClick={this.onAcceptButtonClicked} />
            );
        }
    }

    private onAcceptButtonClicked = (evt: React.MouseEvent<unknown>) => {
        this.setState({ isLoading: true });
        acceptInvite(this.props.item.ItemId)
            .then((success: boolean) => {
                this.setState({ isLoading: false, successfulAccept: success });
            })
            .catch(() => {
                this.setState({ isLoading: false, successfulAccept: false });
            });
    };

    private onViewCalendarButtonClicked(evt: React.MouseEvent<unknown>) {
        const newWindow = window.open();
        showCalendar(newWindow);
    }
}
